import { render, staticRenderFns } from "./btn-check.vue?vue&type=template&id=13291f06&scoped=true&"
import script from "./btn-check.vue?vue&type=script&lang=ts&"
export * from "./btn-check.vue?vue&type=script&lang=ts&"
import style0 from "./btn-check.vue?vue&type=style&index=0&id=13291f06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13291f06",
  null
  
)

export default component.exports